<template>
  <div class="dashboard-container">
    <!-- Header -->
    <v-row class="mb-6">
      <v-col cols="12">
        <h1 class="text-h4 font-weight-bold text-primary mb-2">
          <v-icon class="mr-2" size="large">mdi-view-dashboard</v-icon>
          لوحة التحكم
        </h1>
        <p class="text-subtitle-1 text-grey-darken-1">نظرة عامة على البريد الإلكتروني والأنشطة اليومية</p>
      </v-col>
    </v-row>

    <!-- Info Cards Row -->
    <v-row class="mb-6">
      <!-- Today's Received Mails -->
      <v-col cols="12" md="3">
        <v-card class="stat-card" elevation="3">
          <v-card-text style="  justify-items: center;" class="text-center">
            <v-icon size="48" color="primary" class="mb-3">mdi-inbox-arrow-down</v-icon>
            <div class="text-h4 font-weight-bold text-primary mb-2">{{ receivedCount }}</div>
            <div class="text-subtitle-1">البريد الوارد اليوم</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Today's Sent Mails -->
      <v-col cols="12" md="3">
        <v-card class="stat-card" elevation="3">
          <v-card-text style="  justify-items: center;" class="text-center">
            <v-icon size="48" color="success" class="mb-3">mdi-inbox-arrow-up</v-icon>
            <div class="text-h4 font-weight-bold text-success mb-2">{{ sentCount }}</div>
            <div class="text-subtitle-1">البريد المرسل اليوم</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Current Date -->
      <v-col cols="12" md="3">
        <v-card class="stat-card" elevation="3">
          <v-card-text style="  justify-items: center;" class="text-center">
            <v-icon size="48" color="warning" class="mb-3">mdi-calendar-today</v-icon>
            <div class="text-h4 font-weight-bold text-warning mb-2">{{ currentDate }}</div>
            <div class="text-subtitle-1">التاريخ الحالي</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Current Time -->
      <v-col cols="12" md="3">
        <v-card class="stat-card" elevation="3">
          <v-card-text style="  justify-items: center;" class="text-center">
            <v-icon size="48" color="info" class="mb-3">mdi-clock-outline</v-icon>
            <div class="text-h4 font-weight-bold text-info mb-2">{{ currentTime }}</div>
            <div class="text-subtitle-1">الوقت الحالي</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Priority Mails Carousel -->
    <v-row class="mb-6">
      <v-col cols="12">
        <v-card elevation="3">
          <v-card-title class="d-flex align-center">
            <v-icon class="mr-2" color="error">mdi-alert-circle</v-icon>
            تـــعــمــيــمــات
            <v-spacer></v-spacer>
            <v-chip color="error" variant="outlined" size="small">
              {{ priorityMails.length }} رسالة
            </v-chip>
          </v-card-title>
          
          <v-card-text>
            <v-carousel
              v-if="priorityMails.length > 0"
              height="280"
             :show-arrows=false
              :touch="true"
    cycle
   delimiter-icon="mdi-square"
   hide-delimiter-background
   delimiter-color="black"
  

 


              interval="5000"
              class="priority-carousel"
            >
              <v-carousel-item
                v-for="mail in priorityMails"
                :key="mail.id"
                class="d-flex align-center justify-center"
              
              >
                <v-card
                  class="mail-card mx-auto"
                 
                  elevation="0  "
                >
                  <v-card-text>
                    <div class="d-flex align-center mb-3">
                    
                     
                      <v-spacer></v-spacer>
                      <v-chip color="error" variant="flat" size="small">
                        {{ mail.priority?.name }}
                      </v-chip>
                    </div>
                    
                    <div class="text-h6 font-weight-bold mb-2">{{ mail.subject }}</div>
                    <div class="text-body-1 text-grey-darken-1 mb-3">
                      {{ stripHtml(mail.body)?.slice(0, 150) + (stripHtml(mail.body)?.length > 150 ? '...' : '') }}
                    </div>
                    
                    <div class="d-flex align-center justify-between">
                      <div class="text-body-2 text-grey">
                        <v-icon size="small" class="mr-1">mdi-clock</v-icon>
                        {{ formatDate(mail.sent_at || mail.created_at) }}
                      </div>
                   
                    </div>
                  </v-card-text>
                  <v-card-actions>
                      <v-btn
                        color="primary"
                        variant="outlined"
                        size="small"
                        @click="openMail(mail)"
                      >
                        <v-icon start>mdi-email-open</v-icon>
                        قراءة الرسالة
                      </v-btn>
                    </v-card-actions>
                </v-card>
              </v-carousel-item>
            </v-carousel>
            
            <div v-else class="text-center py-8">
              <v-icon size="64" color="grey-lighten-2" class="mb-4">mdi-email-check</v-icon>
              <div class="text-h6 text-grey">لا توجد رسائل ذات أولوية عالية</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Work Advice News Bar -->
    <v-card class="news-bar-container" elevation="3">
      <v-card-text class="pa-2">
        <div class="d-flex align-center">
          <div class="news-label">
            <v-icon color="white" class="mr-2">mdi-information</v-icon>
            <span class="font-weight-bold text-white"> تنويه : </span>
          </div>
          <div class="news-content">
            <div class="scrolling-text">
              <span v-for="(advice, index) in workAdvices" :key="index" class="advice-item">
                {{ advice }}
                <v-icon class="advice-separator" color="white" size="small">mdi-circle-small</v-icon>
              </span>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <!-- Mail Detail Dialog -->
    <v-dialog v-model="mailDialog" max-width="800px" scrollable>
      <v-card v-if="selectedMail">
        <v-card-title class="d-flex align-center">
          <v-icon class="mr-2" color="error">mdi-email</v-icon>
          {{ selectedMail.subject }}
          <v-spacer></v-spacer>
          <v-btn icon @click="mailDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-subtitle class="pb-0">
          <div class="d-flex align-center mb-2">
            <v-chip color="error" variant="flat" size="small" class="mr-2">
              {{ selectedMail.priority?.name }}
            </v-chip>
          </div>
          <div><strong>من:</strong> {{ selectedMail.sender?.name }} ({{ selectedMail.sender?.email }})</div>
          <div><strong>التاريخ:</strong> {{ formatFullDate(selectedMail.sent_at || selectedMail.created_at) }}</div>
          <div><strong>الإشاري:</strong> {{ selectedMail.ref || 'غير متوفر' }}</div>
          <div><strong>النوع:</strong> {{ selectedMail.mail_type?.name || 'غير متوفر' }}</div>
        </v-card-subtitle>
        
        <v-card-text>
          <div class="message-content" v-html="selectedMail.body?.replace(/\n/g, '<br>')"></div>
        </v-card-text>
        
        <v-card-actions>
          <v-btn color="primary" @click="replyToMail">
            <v-icon start>mdi-reply</v-icon>
            رد
          </v-btn>
          <v-btn color="secondary" @click="forwardMail">
            <v-icon start>mdi-forward</v-icon>
            إعادة توجيه
          </v-btn>
          <v-btn color="info" @click="printMail">
            <v-icon start>mdi-printer</v-icon>
            طباعة
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="error" variant="outlined" @click="mailDialog = false">
            <v-icon start>mdi-close</v-icon>
            إغلاق
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Hidden Print Template -->
    <div ref="printContent" style="display: none;">
      <div class="print-page-with-bg" v-if="selectedMail">
        <!-- Date and Ref Section - Top Right -->
        <div class="print-date-ref">
          <div class="ref-number">الإشاري: {{ selectedMail.ref || 'غير متوفر' }}</div>
          <div class="mail-date">التاريخ: {{ formatPrintDate(selectedMail.sent_at || selectedMail.created_at) }}</div>
          <div class="ref-number">النوع: {{ selectedMail.mail_type?.name || 'غير متوفر' }}</div>
        </div>

        <!-- Mail Content Section -->
        <div class="print-mail-content">
          
          <div class="mail-body" v-html="selectedMail.body?.replace(/\n/g, '<br>')"></div>
        </div>

        <!-- Sender Section - Always at bottom -->
        <div class="print-sender-section">
          <div class="sender-copy-note">
            <i class="mdi mdi-archive"></i><span style="font-weight: bold;">صورة إلى :</span> الأرشــيــف
          </div>
          <div class="sender-left-group">
            <div class="sender-info-text">
              <div class="sender-name">{{ selectedMail.sender?.name }}</div>
              <div class="sender-position">
                {{ getSenderJobTitle() }}
              </div>
            </div>
            
            <div class="stamps-section">
              <div class="sender-signature">
                <img 
                  v-if="selectedMail.sender?.stamp_url"
                  :src="selectedMail.sender.stamp_url" 
                  alt="توقيع المرسل"
                  class="signature-image"
                />
                <div v-else class="signature-placeholder">
                  <div class="signature-line">التوقيع</div>
                </div>
              </div>
              <div class="department-stamp">
                <img 
                  v-if="selectedMail.sender_department?.stamp_url"
                  :src="selectedMail.sender_department.stamp_url" 
                  alt="ختم القسم"
                  class="department-stamp-img"
                />
                <div v-else class="stamp-placeholder">
                  <div class="stamp-text">ختم القسم</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mailService from '../services/mailService'
import authService from '../services/authService'

export default {
  name: 'DashboardView',
  data() {
    return {
      loading: false,
      priorityMails: [],
      receivedCount: 0,
      sentCount: 0,
      currentTime: '',
      currentDate: '',
      mailDialog: false,
      selectedMail: null,
      workAdvices: [
        'تأكد من قفل جهاز الكمبيوتر قبل مغادرة المكتب باستخدام  ',
        'احتفظ بالمشروبات بعيداً عن جهاز الكمبيوتر',
        'لا تفتح روابط خارجية على جهاز العمل',
        'إذا واجهت مشكلة تقنية، اتصل بقسم تقنية المعلومات فوراً',
        'استخدم كلمات مرور قوية ولا تشاركها مع أحد',
        'قم بحفظ عملك بشكل دوري لتجنب فقدان البيانات',
        'تأكد من تحديث برامج الحماية بانتظام',
        'لا تترك معلومات حساسة على الشاشة عند التوقف عن العمل',
        'استخدم شبكة الإنترنت الآمنة فقط للأعمال الرسمية',
        'أبلغ عن أي نشاط مشبوه على الفور'
      ]
    }
  },
  
  async mounted() {
    await this.loadDashboardData()
    this.updateDateTime()
    
    // Update time every minute
    this.timeInterval = setInterval(this.updateDateTime, 60000)
  },
  
  beforeUnmount() {
    if (this.timeInterval) {
      clearInterval(this.timeInterval)
    }
  },
  
  methods: {
    async loadDashboardData() {
      try {
        this.loading = true
        
        // Load priority 6 mails for carousel
        await this.loadPriorityMails()
        
        // Load real mail counts
        await this.loadMailCounts()
        
      } catch (error) {
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'error',
          color: 'error',
          icon: 'mdi-alert-circle',
          timeout: 3000,
          closable: true,
          message: 'فشل في تحميل بيانات لوحة التحكم: ' + (error.message || 'خطأ غير معروف')
        })
      } finally {
        this.loading = false
      }
    },
    
    async loadPriorityMails() {
      try {
        const response = await mailService.getPriorityMails(5)
        this.priorityMails = response.data || []
      } catch (error) {
        console.error('Error loading priority mails:', error)
        // Use mock data if API fails
        this.priorityMails = []
      }
    },

    async loadMailCounts() {
      try {
        // Get today's received count
        const receivedResponse = await mailService.getTodayReceivedCount()
        this.receivedCount = receivedResponse.count || 0

        // Get current user for sent count
        const userProfile = await authService.getProfile()
        const userId = userProfile.data?.id || userProfile.id

        // Get today's sent count
        const sentResponse = await mailService.getTodaySentCount(userId)
        this.sentCount = sentResponse.count || 0

      } catch (error) {
        console.error('Error loading mail counts:', error)
        // Fallback to 0 if there's an error
        this.receivedCount = 0
        this.sentCount = 0
      }
    },
    
    updateDateTime() {
      const now = new Date()
      this.currentTime = now.toLocaleTimeString('ar-LY', { 
        hour: '2-digit', 
        minute: '2-digit'
      })
      this.currentDate = now.toLocaleDateString('ar-LY', {
        weekday: 'narrow',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      })
    },
    
    formatDate(date) {
      return new Date(date).toLocaleDateString('ar-LY', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    
    formatFullDate(date) {
      return new Date(date).toLocaleDateString('ar-LY', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    },

    formatPrintDate(date) {
      return new Date(date).toLocaleDateString('ar-LY', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      })
    },

    getRecipientTitle() {
      // Get the first to_department for the recipient title
      const firstDepartment = this.selectedMail.to_departments?.[0]
      if (firstDepartment) {
        const jobTitle = firstDepartment.department_jobs?.[0]?.name || 'مدير'
        const departmentName = firstDepartment.name || ''
        return `${jobTitle} ${departmentName}`
      }
      return 'مدير تقنية المعلومات'
    },

    getSenderJobTitle() {
      const senderJobTitle = this.selectedMail.sender?.employee_title?.name || 
                            this.selectedMail.sender?.department_job?.name || 
                            'موظف'
      const departmentName = this.selectedMail.sender?.department?.name || ''
      return `${senderJobTitle} - ${departmentName}`
    },

    async getImageAsBase64() {
      try {
        const response = await fetch(require('@/assets/printbg.png'))
        const blob = await response.blob()
        
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = () => {
            const base64 = reader.result.split(',')[1]
            resolve(base64)
          }
          reader.onerror = reject
          reader.readAsDataURL(blob)
        })
      } catch (error) {
        console.error('Error loading background image:', error)
        return ''
      }
    },
    
    openMail(mail) {
      this.selectedMail = mail
      this.mailDialog = true
    },
    
    replyToMail() {
      // Implement reply functionality
      //console.log('Reply to mail:', this.selectedMail.id)
      this.mailDialog = false
    },
    
    forwardMail() {
      // Implement forward functionality
      //console.log('Forward mail:', this.selectedMail.id)
      this.mailDialog = false
    },

    async printMail() {
      if (!this.selectedMail) return;
      
      try {
        // Check if this is original print or copy
        const isOriginalPrint = !this.selectedMail.printed_at;
        //console.log('Print tracking:', { 
          //mailId: this.selectedMail.id, 
          //printedAt: this.selectedMail.printed_at, 
          //isOriginalPrint 
        //});

        // Get the background image as base64
        const backgroundImage = await this.getImageAsBase64();
        
        // Create a new window for printing
        const printWindow = window.open('', '_blank');
        
        if (!printWindow) {
          this.$store.dispatch('alerts/showAlert', {
            id: Date.now(),
            type: 'error',
            color: 'error',
            icon: 'mdi-alert-circle',
            timeout: 3000,
            closable: true,
            message: 'تعذر فتح نافذة الطباعة'
          });
          return;
        }
        
        // Calculate content length to determine if we need multiple pages
        const contentText = this.stripHtml(this.selectedMail.body || '');
        const contentLength = contentText.length;
        
        // More accurate estimation based on actual content area
        // First page has less space (45% height ≈ 1800 chars), continuation pages have more (65% ≈ 2600 chars)
        const firstPageChars = 1800;
        const continuationPageChars = 2600;
        
        let estimatedPages = 1;
        let remainingContent = contentLength;
        
        if (remainingContent > firstPageChars) {
          remainingContent -= firstPageChars;
          estimatedPages += Math.ceil(remainingContent / continuationPageChars);
        }
        
        //console.log('Print Debug:', {
          //contentLength,
          //  firstPageChars,
          //continuationPageChars,
          //estimatedPages,
          //willUseMultiPage: estimatedPages > 1,
          //isOriginalPrint
        //});
        
        // Create multiple page divs
        let pagesHtml = '';
        
        if (estimatedPages <= 1) {
          // Single page layout
          pagesHtml = `
            <div class="print-page-with-bg">
              ${!isOriginalPrint ? '<div class="copy-watermark">نسخة</div>' : ''}
              <!-- Date and Ref Section -->
              <div class="print-date-ref">
                <div class="ref-number">الإشاري: ${this.selectedMail.ref || 'غير متوفر'}</div>
                <div class="mail-date">التاريخ: ${this.formatPrintDate(this.selectedMail.sent_at || this.selectedMail.created_at)}</div>
              </div>
              <div class="print-type-barcode">
                <div class="mail-type-label">النوع: ${this.selectedMail.mail_type?.name || 'غير متوفر'}</div>
                <svg class="barcode-svg" data-ref="${this.selectedMail.ref || ''}"></svg>
              </div>

              <!-- Mail Content Section -->
              <div class="print-mail-content first-page">
                <div class="mail-recipients">السادة : ${(this.selectedMail.departments || []).filter(d => d.pivot?.recipient_type?.toUpperCase() === 'TO').map(d => d.name).join(' , ') || 'غير محدد'}</div>
                <div class="mail-subject">بخصوص : ${this.selectedMail.subject || 'بدون موضوع'}</div>
                <div class="mail-body">${this.selectedMail.body?.replace(/\n/g, '<br>') || ''}</div>
              </div>

              <!-- Sender Section -->
              <div class="print-sender-section">
                <div class="sender-copy-note">
                  <div><i class="mdi mdi-archive"></i> <span style="font-weight: bold;">صورة إلى :</span> الأرشــيــف</div>
                  ${(this.selectedMail.departments || []).filter(d => d.pivot?.recipient_type?.toUpperCase() === 'CC').map(d => d.name).filter(Boolean).map(name => `<div class="copy-recipient">${name}</div>`).join('')}
                </div>
                <div class="sender-left-group">
                  <div class="sender-info-text">
                    <div class="sender-name">${this.selectedMail.sender.employee_title?.short_name || ''} ${this.selectedMail.sender?.name || ''}</div>
                    <div class="sender-position">${this.selectedMail.sender_department_job?.name || '' } ${this.selectedMail.sender_department?.name || ''}</div>
                  </div>
                  <div class="stamps-section">
                    <div class="sender-signature">
                      ${this.selectedMail.sender?.stamp_url ? 
                        `<img src="${this.selectedMail.sender.stamp_url}" alt="توقيع المرسل" class="signature-image" />` :
                        '<div class="signature-placeholder"><div class="signature-line">التوقيع</div></div>'
                      }
                    </div>
                    <div class="department-stamp">
                      ${this.selectedMail.sender_department?.stamp_url ? 
                        `<img src="${this.selectedMail.sender_department.stamp_url}" alt="ختم القسم" class="department-stamp-img" />` :
                        '<div class="stamp-placeholder"><div class="stamp-text">ختم القسم</div></div>'
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          `;
        } else {
          // Multi-page layout - split content accurately
          let currentIndex = 0;
          
          for (let page = 0; page < estimatedPages; page++) {
            const isFirstPage = page === 0;
            const isLastPage = page === estimatedPages - 1;
            
            let pageChars = isFirstPage ? firstPageChars : continuationPageChars;
            let endIndex = Math.min(currentIndex + pageChars, contentLength);
            let pageContent = contentText.slice(currentIndex, endIndex);
            
            // Try to break at word boundaries when possible (but not on last page)
            if (!isLastPage && endIndex < contentLength) {
              const lastSpaceIndex = pageContent.lastIndexOf(' ');
              if (lastSpaceIndex > pageContent.length * 0.7) { // Only adjust if space is reasonably near the end
                pageContent = pageContent.slice(0, lastSpaceIndex);
                endIndex = currentIndex + lastSpaceIndex;
              }
            }
            
            // Convert back to HTML format
            pageContent = pageContent.replace(/\n/g, '<br>');
            
            pagesHtml += `
              <div class="print-page-with-bg">
                ${isFirstPage && !isOriginalPrint ? '<div class="copy-watermark">نسخة</div>' : ''}
                ${isFirstPage ? `
                  <!-- Date and Ref Section -->
                  <div class="print-date-ref">
                    <div class="ref-number">الإشاري: ${this.selectedMail.ref || 'غير متوفر'}</div>
                    <div class="mail-date">التاريخ: ${this.formatPrintDate(this.selectedMail.sent_at || this.selectedMail.created_at)}</div>
                  </div>
                  <div class="print-type-barcode">
                    <div class="mail-type-label">النوع: ${this.selectedMail.mail_type?.name || 'غير متوفر'}</div>
                    <svg class="barcode-svg" data-ref="${this.selectedMail.ref || ''}"></svg>
                  </div>
                ` : ''}

                <!-- Mail Content Section -->
                <div class="print-mail-content ${isFirstPage ? 'first-page' : 'continuation-page'}">
                  ${isFirstPage ? `
                    <div class="mail-recipients">السادة : ${(this.selectedMail.departments || []).filter(d => d.pivot?.recipient_type?.toUpperCase() === 'TO').map(d => d.name).join(' , ') || 'غير محدد'}</div>
                    <div class="mail-subject">بخصوص : ${this.selectedMail.subject || 'بدون موضوع'}</div>
                  ` : ''}
                  <div class="mail-body">${pageContent}</div>
                </div>

                ${isLastPage ? `
                  <!-- Sender Section -->
                  <div class="print-sender-section">
                    <div class="sender-copy-note">
                      <div><i class="mdi mdi-archive"></i> <span style="font-weight: bold;">صورة إلى :</span> الأرشــيــف</div>
                      ${(this.selectedMail.departments || []).filter(d => d.pivot?.recipient_type?.toUpperCase() === 'CC').map(d => d.name).filter(Boolean).map(name => `<div class="copy-recipient">${name}</div>`).join('')}
                    </div>
                    <div class="sender-left-group">
                      <div class="sender-info-text">
                        <div class="sender-name">${this.selectedMail.sender?.name || ''}</div>
                        <div class="sender-position">${this.getSenderJobTitle()}</div>
                      </div>
                      <div class="stamps-section">
                        <div class="sender-signature">
                          ${this.selectedMail.sender?.stamp_url ? 
                            `<img src="${this.selectedMail.sender.stamp_url}" alt="توقيع المرسل" class="signature-image" />` :
                            '<div class="signature-placeholder"><div class="signature-line">التوقيع</div></div>'
                          }
                        </div>
                        <div class="department-stamp">
                          ${this.selectedMail.sender?.department?.stamp_url ? 
                            `<img src="${this.selectedMail.sender.department.stamp_url}" alt="ختم القسم" class="department-stamp-img" />` :
                            '<div class="stamp-placeholder"><div class="stamp-text">ختم القسم</div></div>'
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                ` : ''}
              </div>
            `;
            
            currentIndex = endIndex;
          }
        }
        
        printWindow.document.write(`
          <!DOCTYPE html>
          <html>
          <head>
            <title>طباعة المراسلة</title>
            <link rel="preconnect" href="https://fonts.googleapis.com">
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
            <link href="https://fonts.googleapis.com/css2?family=Cairo:wght@200..1000&display=swap" rel="stylesheet">
            <style>
              * { 
                margin: 0; 
                padding: 0; 
                box-sizing: border-box; 
                font-family: 'cairo', sans-serif; 
              }
              body { 
                font-family: 'cairo', sans-serif; 
                direction: rtl; 
                margin: 0;
                padding: 0;
              }
              @page { 
                size: A4; 
                margin: 0; 
              }
              @media print { 
                body { margin: 0; padding: 0; }
                .print-page-with-bg { box-shadow: none; margin: 0; }
                * {
                  -webkit-print-color-adjust: exact !important;
                  color-adjust: exact !important;
                }
              }
              
              .print-page-with-bg {
                width: 210mm;
                height: 297mm;
                margin: 0 auto;
                background-image: url('data:image/png;base64,${backgroundImage}');
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                font-family: 'cairo', sans-serif;
                color: black;
                position: relative;
                padding: 0;
                page-break-after: always;
              }
              
              .print-page-with-bg:last-child {
                page-break-after: auto;
              }
              
              /* Date and Ref Section - Top Right with margin for header */
              .print-date-ref {
                position: absolute;
                top: 15%;
                right: 15mm;
                text-align: right;
                color: #004aad;
                font-size: 14px;
                line-height: 1.6;
              }

              .print-type-barcode {
                position: absolute;
                top: 15%;
                left: 15mm;
                text-align: center;
                color: #004aad;
                font-size: 14px;
              }

              .mail-type-label {
                font-weight: bold;
                margin-bottom: 6px;
              }

              .barcode-svg {
                display: block;
              }
              
              .ref-number, .mail-date {
                margin-bottom: 8px;
                font-weight: bold;
              }
              
              /* Mail Content Section */
              .print-mail-content.first-page {
                position: absolute;
                top: 25%; /* Below header and date/ref section */
                left: 20mm;
                right: 20mm;
                height: 45%; /* Fixed height to prevent overflow into footer */
                text-align: right;
                overflow: hidden;
              }
              
              .print-mail-content.continuation-page {
                position: absolute;
                top: 15%; /* Below header (10% + 5% buffer) */
                left: 20mm;
                right: 20mm;
                height: 65%; /* More space on continuation pages */
                text-align: right;
                overflow: hidden;
              }
              
              .mail-recipients {
                font-size: 15px;
                font-weight: bold;
                margin-bottom: 10px;
                text-align: right;
              }

              .mail-subject {
                font-size: 15px;
                font-weight: bold;
                margin-bottom: 15px;
                text-align: right;
                text-decoration: underline;
              }
              
              .mail-body {
                font-size: 14px;
                line-height: 1.8;
                text-align: justify;
                text-indent: 20px;
                word-wrap: break-word;
                overflow-wrap: break-word;
              }
              
              /* Sender Section - Always at bottom with margin for footer */
              .print-sender-section {
                position: absolute;
                bottom: 10%;
                left: 20mm;
                right: 20mm;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                min-height: 120px;
              }

              .sender-left-group {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
              }
              
              .sender-info-text {
                text-align: center;
                margin-bottom: 10px;
              }

              .sender-copy-note {
                font-size: 14px;
                align-self: flex-end;
              }

              .copy-recipient {
                font-size: 14px;
                line-height: 1.6;
              }

              .copy-recipient::before {
                content: '\\200B صورة إلى : ';
                visibility: hidden;
                font-weight: bold;
              }
              
              .sender-name {
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 5px;
              }
              
              .sender-position {
                font-size: 14px;
                margin-bottom: 10px;
              }
              
              .stamps-section {
                display: flex;
                align-items: flex-end;
                gap: 20px;
              }
              
              .department-stamp {
                text-align: center;
                margin-left: 10px;
              }
              
              .department-stamp-img {
                width: 100px;
                height: 100px;
                object-fit: contain;
                border-radius: 50%;
              }
              
              .stamp-placeholder {
                width: 100px;
                height: 100px;
                border: 2px solid black;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                background: rgba(255, 255, 255, 0.8);
              }
              
              .stamp-text {
                font-size: 12px;
                font-weight: bold;
                text-align: center;
              }
              
              .sender-signature {
                text-align: center;
              }
              
              .signature-image {
                width: 75px;
                height: 75px;
                object-fit: contain;
              }
              
              .signature-placeholder {
                width: 75px;
                height: 75px;
                border: 1px solid black;
                display: flex;
                align-items: center;
                justify-content: center;
                background: rgba(255, 255, 255, 0.8);
              }
              
              .signature-line {
                font-size: 12px;
                font-weight: bold;
                text-align: center;
              }
              
              /* Copy watermark */
              .copy-watermark {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) rotate(-45deg);
                font-size: 80px;
                font-weight: bold;
                color: rgba(200, 200, 200, 0.3);
                z-index: 1;
                pointer-events: none;
                user-select: none;
                font-family: 'cairo', sans-serif;
              }
            </style>
          </head>
          <body>
            ${pagesHtml}
          </body>
          </html>
        `);
        
        printWindow.document.close();
        printWindow.focus();

        const barcodeScript = printWindow.document.createElement('script');
        barcodeScript.src = 'https://cdn.jsdelivr.net/npm/jsbarcode@3.11.6/dist/JsBarcode.all.min.js';
        barcodeScript.onload = function() {
          var svgs = printWindow.document.querySelectorAll('.barcode-svg');
          for (var i = 0; i < svgs.length; i++) {
            var val = svgs[i].getAttribute('data-ref') || 'N/A';
            try {
              printWindow.JsBarcode(svgs[i], val, {
                format: 'CODE128',
                width: 1.5,
                height: 40,
                displayValue: false,
                margin: 5
              });
            } catch(e) { console.error('Barcode error:', e); }
          }
        };
        printWindow.document.head.appendChild(barcodeScript);
        
        setTimeout(() => {
          printWindow.print();
          printWindow.close();
        }, 2500);
        
        // Mark as printed if this is the original print
        if (isOriginalPrint) {
          try {
            await mailService.markAsPrinted(this.selectedMail.id);
            //console.log('Mail marked as printed successfully');
            // Update the local mail object to reflect the change
            this.selectedMail.printed_at = new Date().toISOString();
          } catch (markError) {
            console.error('Error marking mail as printed:', markError);
            // Don't show error to user as the print was successful
          }
        }
        
      } catch (error) {
        console.error('Error printing message:', error);
        this.$store.dispatch('alerts/showAlert', {
          id: Date.now(),
          type: 'error',
          color: 'error',
          icon: 'mdi-alert-circle',
          timeout: 3000,
          closable: true,
          message: 'فشل في الطباعة: ' + (error.message || 'خطأ غير معروف')
        });
      }
    },

    stripHtml(html) {
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || '';
    }
  }
}
</script>

<style scoped>
.dashboard-container {
  padding: 24px;
  min-height: 100vh;
  background: transparent;
}

.stat-card {
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  border-radius: 12px;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
}

.priority-carousel {
  border-radius: 8px;
}

.mail-card {
  width: 100%;
  border-radius: 12px;
  background: white;
}

.news-bar-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  border-radius: 0;
  background: red;
  color: white;
}

.news-label {
  flex: 0 0 auto;
  padding-right: 16px;
  color: white;
}

.news-content {
  flex: 1;
  overflow: hidden;
  height: 30px;
  display: flex;
  align-items: center;
}

.scrolling-text {
  animation: scroll-right 60s linear infinite;
  white-space: nowrap;
  color: white;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.advice-item {
  margin-left: 40px;
  display: inline-flex;
  align-items: center;
}

.advice-separator {
  margin: 0 8px;
}

@keyframes scroll-right {
  0% {
    transform: translateX(-50%);
  }
  100% {
    transform: translateX(100%);
  }
}

.message-content {
  font-size: 14px;
  line-height: 1.6;
  max-height: 400px;
  overflow-y: auto;
}

/* RTL specific styles */
.v-carousel__controls {
  direction: ltr;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .dashboard-container {
    padding: 16px;
  }
  
  .mail-card {
    margin: 8px;
  }
}

/* Print Styles */
@media print {
  * {
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
  }
  
  body {
    margin: 0;
    padding: 0;
  }
  
  .print-page-with-bg {
    box-shadow: none !important;
  }
}

/* Print Page with Background */
.print-page-with-bg {
  width: 210mm;
  height: auto;
  min-height: 297mm;
  margin: 0 auto;
  background-image: url('@/assets/printbg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  font-family: 'cairo', sans-serif;
  color: black;
  position: relative;
  padding: 0;
}

/* Date and Ref Section - Top Right with margin for header */
.print-date-ref {
  position: absolute;
  top: 15%; /* Below header (10% + 5% buffer) */
  right: 15mm;
  text-align: right;
  color: #004aad;
  font-size: 14px;
  line-height: 1.6;
}

.ref-number, .mail-date {
  margin-bottom: 8px;
  font-weight: bold;
}

/* Mail Content Section - Below date/ref */
.print-mail-content {
  position: absolute;
  top: 25%; /* Below header and date/ref section */
  left: 20mm;
  right: 20mm;
  bottom: 20%; /* Reserve space for signature and footer */
  text-align: right;
  overflow: hidden;
}

.mail-recipients {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: right;
}

.mail-subject {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 15px;
  text-align: right;
  text-decoration: underline;
}

.mail-body {
  font-size: 14px;
  line-height: 1.8;
  text-align: justify;
  text-indent: 20px;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/* Sender Section - Always at bottom with margin for footer */
.print-sender-section {
  position: absolute;
  bottom: 10%;
  left: 20mm;
  right: 20mm;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  min-height: 120px;
}

.sender-left-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.sender-info-text {
  text-align: center;
  margin-bottom: 10px;
}

.sender-copy-note {
  font-size: 14px;
  align-self: flex-end;
}

.copy-recipient {
  font-size: 14px;
  line-height: 1.6;
}

.sender-name {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}

.sender-position {
  font-size: 14px;
  margin-bottom: 10px;
}

.stamps-section {
  display: flex;
  align-items: flex-end;
  gap: 20px;
}

/* Department Stamp */
.department-stamp {
  text-align: center;
  margin-left: 10px;
}

.department-stamp-img {
  width: 100px;
  height: 100px;
  object-fit: contain;
  border-radius: 50%;
}

.stamp-placeholder {
  width: 100px;
  height: 100px;
  border: 2px solid black;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
}

.stamp-text {
  font-size: 12px;
  font-weight: bold;
  text-align: center;
}

/* Sender Signature */
.sender-signature {
  text-align: center;
}

.signature-image {
  width: 75px;
  height: 75px;
  object-fit: contain;
}

.signature-placeholder {
  width: 75px;
  height: 75px;
  border: 1px solid black;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
}

.signature-line {
  font-size: 12px;
  font-weight: bold;
  text-align: center;
}
</style> 